module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "idFrameBody",
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "flex-direction": "row",
      "border": "0px solid #ff0000"
    },
    attrs: {
      "id": "idFrameBody"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1 0 auto",
      "border": "0px solid red"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('div', {
    ref: "idBodySplit1",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0px solid red",
      "height": "10px"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idOPBody",
    staticStyle: {
      "flex": "1 1 auto",
      "border": "1px solid #e1e1e1",
      "overflow": "hidden"
    },
    attrs: {
      "id": "idOPBody"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    ref: "idBodySplit2",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0px solid red",
      "height": "10px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0px solid red",
      "width": "10px"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-450af646","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/FrameBody.vue
// module id = 767
// module chunks = 1